export default __webpack_public_path__ + "static/media/coke.footer.0413c9db.png";